import classNames from 'classnames';
import difference from 'lodash/difference';
import forEach from 'lodash/forEach';
import map from 'lodash/map';
import React from 'react';
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import swal from 'sweetalert2';
import {
  createCollection,
  getCollections,
  getJerseys,
  orderCollections,
  updateCollectionInfos,
} from '../../../actions/entities/jerseys';
import {getParameterByName} from '../../../helpers/location';
import {CollectionDetails} from '../CollectionDetails';
import {uploadPicture} from '../uploadPicture';
import crossImg from './cross.png';
import './index.css';
import JerseysList from './jerseysList';

class CollectionsList extends React.Component {
  state = {
    selected: getParameterByName('lang', window.location.href) || 'fr-FR',
    selectedCollectionIndex: null,
    collectionPayload: null,
    updateJerseysIdsCollectionIndex: null,
  };

  componentDidMount() {
    const {dispatch} = this.props;
    dispatch(getCollections({language: this.state.selected}));
    dispatch(getJerseys());
  }

  onError = error => {
    swal({
      title: `Oops...`,
      type: 'error',
      html:
        `Something went wrong:<br/>${error}<br/>` +
        `<pre><code>${JSON.stringify(error, undefined, 4)}</code></pre>`,
    });
  };

  onClickEdit(i) {
    this.setState({
      selectedCollectionIndex: i,
      collectionPayload: {...this.props.collectionsList[i]},
    });
  }

  componentDidUpdate(prevProps, prevState) {
    // if (
    //   prevState.selectedCollectionIndex !==
    //     this.state.selectedCollectionIndex ||
    //   (prevProps.collectionsList &&
    //     this.props.collectionsList &&
    //     this.state.selectedCollectionIndex &&
    //     prevProps.collectionsList[this.state.selectedCollectionIndex].id !==
    //       this.props.collectionsList[this.state.selectedCollectionIndex].id)
    // ) {
    //   this.setState({
    //     collectionPayload: {
    //       ...this.props.collectionsList[this.state.selectedCollectionIndex],
    //     },
    //   });
    // }
  }

  updateInfos = () => {
    const {dispatch} = this.props;
    const {selected} = this.state;
    const onSuccess = () => {
      dispatch(getCollections({language: this.state.selected}));
    };
    dispatch(
      updateCollectionInfos(
        {
          id: undefined,
          name: this.state.collectionPayload.name,
          startDate: this.state.collectionPayload.startDate,
          endDate: this.state.collectionPayload.endDate,
          imageUrl: this.state.collectionPayload.imageUrl,
          isDrop: this.state.collectionPayload.isDrop,
          jerseysIds: this.state.collectionPayload.jerseysIds,
          isPinned: this.state.collectionPayload.isPinned,
          description: this.state.collectionPayload.description,
          backgroundImageUrl: this.state.collectionPayload.backgroundImageUrl,
        },
        selected,
        this.state.collectionPayload.id,
        onSuccess,
        error => {
          if (error.message === 'onlyOneDropAtATime') {
            this.setState({
              collectionPayload: {
                ...this.state.collectionPayload,
                isDrop: false,
              },
            });
          }
          swal({
            title: `Oops...`,
            type: 'error',
            html:
              `Something went wrong:<br/>${error}<br/>` +
              `<pre><code>${JSON.stringify(error, undefined, 4)}</code></pre>`,
          });
        },
      ),
    );
  };

  submitCreation = () => {
    const {dispatch} = this.props;
    const onSuccess = () => {
      swal({
        title: 'Created !',
        type: 'success',
      });
      dispatch(
        getCollections(
          {language: this.state.selected},
          ({jerseyCollectionsTemp}) => {
            this.changePosition(
              this.state.collectionPayload.position || 0,
              jerseyCollectionsTemp.length - 1,
              jerseyCollectionsTemp,
              () => {
                dispatch(
                  getCollections({language: this.state.selected}, data => {
                    this.setState({
                      collectionPayload: {
                        ...data.jerseyCollectionsTemp[
                          this.state.collectionPayload.position
                        ],
                      },
                    });
                  }),
                );
              },
            );
          },
          this.onError,
        ),
      );
    };
    dispatch(
      createCollection(
        {
          ...this.state.collectionPayload,
          position: undefined,
          language: this.state.selected,
        },
        onSuccess,
        this.onError,
      ),
    );
  };

  toggleLang(value) {
    const {dispatch} = this.props;
    this.setState({
      selected: value,
      isEdit: false,
    });
    dispatch(getCollections({language: value}, null, this.onError));
  }

  renderJerseyList(idList, jerseys, collectionIndex) {
    const list = [];

    forEach(idList, (id, i) => {
      const {tag} = jerseys[id];
      list.push(
        <Draggable
          key={`${jerseys[id].id}-${collectionIndex}`}
          draggableId={`${jerseys[id].id}-${collectionIndex}`}
          index={i}>
          {provided => (
            <div
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              className="jerseyItem">
              <div className="image">
                <img
                  className="img"
                  src={`${jerseys[id].imageUrl}?nocache=${new Date()}`}
                  alt=""
                />
              </div>
              {tag && <div className="tag">{tag}</div>}
              {this.state.selectedCollectionIndex === collectionIndex && (
                <div className="text-center">
                  <i
                    onClick={() =>
                      this.deleteJerseyFromCollection(collectionIndex, i)
                    }
                    className="fa fa-times-circle deleteJersey"
                  />
                </div>
              )}
            </div>
          )}
        </Draggable>,
      );
    });
    list.push(
      <div
        key={`addButton${collectionIndex}`}
        className="jerseyItem"
        onClick={() =>
          this.setState({
            updateJerseysIdsCollectionIndex:
              this.state.updateJerseysIdsCollectionIndex === collectionIndex
                ? null
                : collectionIndex,
          })
        }>
        <div
          style={{
            backgroundColor:
              this.state.updateJerseysIdsCollectionIndex === collectionIndex &&
              '#f39c12',
          }}
          className="image">
          <img className="img" src={crossImg} alt="" />
        </div>
      </div>,
    );
    return list.map(li => li);
  }

  static moveIndexArray(from, to, array) {
    array.splice(to, 0, array.splice(from, 1)[0]);
  }

  changePosition = (
    to,
    from,
    array = this.props.collectionsList,
    onSuccess = () => {},
  ) => {
    const {dispatch} = this.props;
    let jerseyCollectionsOrdered = map(array, c => c.id);
    CollectionsList.moveIndexArray(from, to, jerseyCollectionsOrdered);
    const onSuccessOrder = () => {
      this.setState({
        selectedCollectionIndex: to,
        collectionPayload: {...array[from], position: to},
      });
      dispatch(getCollections({language: this.state.selected}));
      onSuccess();
    };
    dispatch(
      orderCollections(
        {orderedJerseyCollections: jerseyCollectionsOrdered},
        onSuccessOrder,
        this.onError,
      ),
    );
  };

  onDragEnd = result => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const {collectionsList, dispatch} = this.props;
    const collIndexSource = result.source.droppableId.split('-')[1];
    const collIndexDest = result.destination.droppableId.split('-')[1];
    if (collIndexDest === collIndexSource) {
      const jerseysIds = collectionsList[collIndexSource].jerseysIds || [];
      const sourceIndex = result.source.index;
      const destIndex = result.destination.index;
      const onSuccess = () => {
        dispatch(getCollections({language: this.state.selected}));
      };
      CollectionsList.moveIndexArray(sourceIndex, destIndex, jerseysIds);
      dispatch(
        updateCollectionInfos(
          {jerseysIds},
          this.state.selected,
          collectionsList[collIndexSource].id,
          onSuccess,
          this.onError,
        ),
      );
    }
  };

  filterJerseysList(jerseysList, jerseysToRemove) {
    return map(
      difference(
        map(jerseysList, j => j.id),
        jerseysToRemove,
      ),
      id => jerseysList[id],
    );
  }

  addJerseyToCollection(jerseyId, collectionInfos) {
    const jerseysIds = collectionInfos.jerseysIds;
    jerseysIds.push(jerseyId);
    this.setState(
      {
        collectionPayload: {jerseysIds, id: collectionInfos.id},
      },
      () => {
        this.updateInfos();
      },
    );
  }

  deleteJerseyFromCollection(collectionIndex, jerseyIndex) {
    const {collectionsList} = this.props;
    const jerseysIds = collectionsList[collectionIndex].jerseysIds;
    jerseysIds.splice(jerseyIndex, 1);
    this.setState(
      {
        collectionPayload: {
          jerseysIds,
          id: collectionsList[collectionIndex].id,
        },
      },
      () => {
        this.updateInfos();
      },
    );
  }

  render() {
    const {collectionsList, jerseysList} = this.props;
    const {
      selected,
      selectedCollectionIndex,
      collectionPayload,
      updateJerseysIdsCollectionIndex,
    } = this.state;
    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <div id="CollectionsList">
          <div className="lang text-center">
            <Link
              to={`/jerseys/collections?lang=fr-FR`}
              className={classNames('btn btn-box-tool', {
                selected: selected === 'fr-FR',
              })}
              onClick={() => this.toggleLang('fr-FR')}>
              <span className="flag-icon flag-icon-fr" />
            </Link>
            <Link
              to={`/jerseys/collections?lang=en-GB`}
              className={classNames('btn btn-box-tool', {
                selected: selected === 'en-GB',
              })}
              onClick={() => this.toggleLang('en-GB')}>
              <span className="flag-icon flag-icon-gb" />
            </Link>
            <Link
              to={`/jerseys/collections?lang=es-ES`}
              className={classNames('btn btn-box-tool', {
                selected: selected === 'es-ES',
              })}
              onClick={() => this.toggleLang('es-ES')}>
              <span className="flag-icon flag-icon-es" />
            </Link>
          </div>
          <div className="text-center m-4">
            <Link
              to={`/jerseys/preview?lang=${selected}`}
              className="btn btn-success">
              Preview
            </Link>
          </div>
          <section className="content">
            <div className="row">
              <div className="row">
                <div className="col-md-6">
                  <div className="box box-default">
                    <div className="box-header with-border">
                      <h3 className="box-title pull-left">
                        <i className="fa fa-plus-circle" /> Collections List
                      </h3>
                    </div>
                    <div
                      style={{maxHeight: '800px'}}
                      className="table-fixed-height">
                      <div className="text-center">
                        <button
                          className="btn btn-success m-3"
                          onClick={() =>
                            this.setState({
                              selectedCollectionIndex: null,
                              collectionPayload: {
                                name: '',
                              },
                            })
                          }>
                          Create Collection
                        </button>
                      </div>
                      {jerseysList &&
                        map(collectionsList, (c, index) => {
                          return (
                            <div
                              key={`droppable-${index}`}
                              className="collectionContainer">
                              <div>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    width: '100%',
                                    alignItems: 'center',
                                  }}>
                                  <img
                                    style={{
                                      marginRight: 16,
                                      objectFit: 'cover',
                                      width: 24,
                                      height: 24,
                                      borderRadius: 24,
                                    }}
                                    src={`${c.imageUrl}`}
                                    alt=""
                                  />
                                  <div className="dotted">{c.name}</div>
                                </div>
                                <div
                                  style={{
                                    textAlign: 'right',
                                    marginRight: '10px',
                                  }}>
                                  <button
                                    className={
                                      selectedCollectionIndex === index
                                        ? 'btn btn-warning'
                                        : 'btn btn-success'
                                    }
                                    onClick={() => this.onClickEdit(index)}>
                                    Edit
                                  </button>
                                </div>
                                <Droppable
                                  droppableId={`droppable-${index}`}
                                  direction="horizontal">
                                  {provided => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.droppableProps}
                                      className="jerseyList">
                                      {this.renderJerseyList(
                                        c.jerseysIds,
                                        jerseysList,
                                        index,
                                      )}
                                    </div>
                                  )}
                                </Droppable>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
                {jerseysList &&
                  collectionsList &&
                  updateJerseysIdsCollectionIndex !== null &&
                  collectionsList[updateJerseysIdsCollectionIndex] && (
                    <JerseysList
                      jerseysList={this.filterJerseysList(
                        jerseysList,
                        collectionsList[updateJerseysIdsCollectionIndex]
                          .jerseys,
                      )}
                      onAdd={jerseyId =>
                        this.addJerseyToCollection(
                          jerseyId,
                          collectionsList[updateJerseysIdsCollectionIndex],
                        )
                      }
                      title={
                        collectionsList[updateJerseysIdsCollectionIndex].name
                      }
                    />
                  )}
                {collectionPayload && (
                  <CollectionDetails
                    isEditing={selectedCollectionIndex !== null}
                    details={collectionPayload}
                    errors={{}}
                    onChangeDetails={(value, key) =>
                      this.setState({
                        collectionPayload: {
                          ...this.state.collectionPayload,
                          [key]: value,
                        },
                      })
                    }
                    onUpdateCollection={() => this.updateInfos()}
                    onOrderCollections={index => {
                      this.changePosition(index, collectionPayload.position);
                    }}
                    collectionsList={collectionsList}
                    onCreateCollection={this.submitCreation}
                    onUpload={file => {
                      this.props.dispatch(
                        uploadPicture(
                          file,
                          imageUrl =>
                            this.setState({
                              collectionPayload: {
                                ...this.state.collectionPayload,
                                imageUrl,
                              },
                            }),
                          'jersey-collection',
                        ),
                      );
                    }}
                    onUploadBackground={file => {
                      this.props.dispatch(
                        uploadPicture(
                          file,
                          backgroundImageUrl =>
                            this.setState({
                              collectionPayload: {
                                ...this.state.collectionPayload,
                                backgroundImageUrl,
                              },
                            }),
                          'jersey-collection',
                        ),
                      );
                    }}
                  />
                )}
              </div>
            </div>
          </section>
        </div>
      </DragDropContext>
    );
  }
}

export default connect(
  state => ({
    collectionsList: state.app.jerseys.collections.data,
    jerseysList: state.app.jerseys.list.data,
  }),
  dispatch => ({dispatch}),
)(CollectionsList);



// WEBPACK FOOTER //
// ./src/pages/Jerseys/CollectionsList/index.js